export const UP_ARROW = 38;
export const DOWN_ARROW = 40;
export const ESCAPE = 27;
export const ENTER = 13;
